import { createAction } from 'typesafe-actions';

export const changeFloorMaxAction = createAction('filters/maxFloorChanged')<number>();
